export default __webpack_public_path__ + "static/media/ABChanelCorpo-SemiBold.a7c67b45.woff2";